import { Card, CardBody, Col, Input, Label } from "reactstrap";
import React from "react";
import { useSelector } from "react-redux";
import Select from "../../Common/AppSelect";
import { isEmpty } from "lodash";
import "./createContract.styles.scss";
import * as moment from "moment";
import { AppDatePicker } from "../../Common/AppDateTimePicker";
import { handleValidDateTime } from "../../Common/HandleDateTime";
// Change #100067 - retired products are not offered when adding a line.
import { isProductActive } from "../../../helpers/functions/productActive";

export default function TabContractItems({
  toggleVerticalTab,
  activeVerticalTab,
  helperSwapNumber,
  contractItems_list,
  setContractItems_list,
  searchResults,
  searchQuery,
  setSearchQuery,
  sortByChoice,
  sortBy,
  setSortBy,
  setSortByChoice,
  customersList,
  contractItemObject,
}) {
  const { productList } = useSelector((state) => ({
    productList: state.ProductCrmIT.productList?.product_list,
  }));
  console.log("product List", productList);
  const { productUnitTypeList } = useSelector((state) => ({
    productUnitTypeList: state.ProductCrmIT.productUnitTypeList?.unittype_list,
  }));
  //Contract Item Renewal Frequency
  const { contractItemRenewalFrequencyList } = useSelector((state) => ({
    contractItemRenewalFrequencyList:
      state.Contract.contractItemRenewalFrequencyList?.renewalfrequency_list,
  }));

  const addItem = () => {
    // set Previous Id show_item: false
    //set seearch to empty
    setSearchQuery("");
    setContractItems_list((prevState) => {
      const newState = [...prevState];
      if (newState.length > 0) {
        newState[newState.length - 1].show_item = false;
      }
      return newState;
    });

    setContractItems_list([
      ...contractItems_list,
      {
        // get last id and add 1

        id:
          contractItems_list.length === 0
            ? 1
            : contractItems_list[contractItems_list.length - 1]?.id + 1,
        Title: "",
        description: "",
        selectedProduct: [],
        rate: 0.0,
        selectedProductUnit: [],
        quantity: 1,
        price: 0,
        vatRate: 20,
        totalExVat: 0,
        totalIncVat: 0,
        AllowedJobAllocation: 2,
        StartDateTime: "",
        EndDateTime: "",
        RenewalPeriodStartDateTime: "",
        show_item: true,
        whiteLabel: false,
        WhiteLabel__Customer_Id: null,
        NewItemLine: true,
        FlagCommitmentEnabled: "0",
        CommitmentStartDateTime: "",
        CommitmentEndDateTime: "",
        CommitmentRenewalDateTime: "",
        AutoEmailCustomer: "0",
        CreditMins: "",
        CreditMinsShow: false,
        TimeTracked: "0",
        DueDateTimeLogicValue: "",
        DueDateTimeLogic_MasterTimeFrameInterval_Id: [],
        // Change #100719 - new lines follow the product's price
        PricingSource: "PRODUCT",
        PricingDateMode: "PERIOD_START",
      },
    ]);
  };
  //create remove item function on click of remove item button
  const removeItem = (id) => {
    setContractItems_list(contractItems_list.filter((item) => item.id !== id));
  };
  const handleRemoveVatRate = (e) => {
    if (e === "") {
      return "";
    }
    return e?.replace("%", "");
  };
  const handleRemovePoundRate = (e) => {
    if (e === "") {
      return "";
    }
    return e?.replace("£", "");
  };

  const handleRenewalFrequencyDueDate = (startDate, frequency) => {
    if (!startDate || !frequency) return;

    switch (frequency?.id) {
      case "1":
        // 1 = 1 month before start date and return date
        return (
          <>
            {/*//if date is in the past make it red if not make it green*/}

            {moment(startDate).subtract(1, "months").format("DD-MM-YYYY")}
          </>
        );
      case "2":
        // 2 = 2 months before start date
        return (
          <>{moment(startDate).subtract(2, "months").format("DD-MM-YYYY")}</>
        );

      default:
        return <>{moment(startDate).format("DD-MM-YYYY")}</>;
    }
  };

  return (
    <>
      {" "}
      <div>
        <div>
          <h5>Contract Items</h5>
          <input
            className={"form-control"}
            type={"search"}
            placeholder={"Search"}
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
          />
        </div>
        <div>
          <div className={"d-flex "}>
            {sortByChoice.map((item) => (
              <div
                className={"me-2 mt-2 cursor-pointer"}
                key={item.id}
                onClick={() => {
                  setSortBy(item.id);
                  // flip ascending
                  setSortByChoice((prevState) => {
                    const newState = [...prevState];
                    newState.forEach((item) => {
                      if (item.id === sortBy) {
                        item.ascending = !item.ascending;
                      }
                    });
                    return newState;
                  });
                }}
              >
                <span className={"badge badge-soft-info"}>{item?.label} </span>{" "}
                {item.id === sortBy && (
                  <>
                    {item.ascending ? (
                      <i className="fa-solid fa-caret-up"></i>
                    ) : (
                      <i className="fa-solid fa-caret-down"></i>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div>
        <div className="">
          <div className="table-responsive">
            <div className={"main-contract-items-table-container"}>
              <div className={"maped-contract-item-list"}>
                {searchResults?.map((item, index) => {
                  return (
                    <Card
                      key={index}
                      className={"contract-items-list-card"}
                      style={{
                        background: item.NewItemLine
                          ? "rgba(232,248,229,0.27)"
                          : "",
                      }}
                    >
                      <CardBody>
                        <div className={"contract-item-list"}>
                          <div className={"contract-item-section1-row pt-1"}>
                            <div
                              className={"d-flex flex-column"}
                              onClick={() => {
                                // toggle show
                                setContractItems_list((prevState) => {
                                  const newState = [...prevState];
                                  newState.find(
                                    (newItemState) =>
                                      newItemState.id === item.id
                                  ).show_item = !newState.find(
                                    (newItemState) =>
                                      newItemState.id === item.id
                                  ).show_item;
                                  return newState;
                                });
                              }}
                            >
                              {item?.selectedProduct?.label && (
                                <div>
                                  <h6 className="ml-2">
                                    {item?.selectedProduct?.label}
                                  </h6>
                                </div>
                              )}
                              <div className={"d-flex flex-row"}>
                                <h6># {item?.id}</h6>
                                {!item?.show_item && (
                                  <i className="fa-solid fa-caret-down ps-2 pe-2"></i>
                                )}
                                {item?.show_item && (
                                  <i className="fa-solid fa-caret-up ps-2 pe-2"></i>
                                )}
                                {/*// Product Name*/}

                                {item?.Title && (
                                  <div>
                                    <h6 className="ml-2">{item?.Title}</h6>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className={"remove-item-from-the-list"}>
                              <div>
                                {contractItems_list?.length > 1 ? (
                                  <span
                                    onClick={() => removeItem(item?.id)}
                                    className="btn btn-danger m-0 p-1 pe-2 ps-2"
                                  >
                                    <i className="fa-regular fs-8 fa-trash-can"></i>
                                  </span>
                                ) : null}
                              </div>
                              <div className={"pt-1"}>
                                <span
                                  // onClick duplicate item and  item increase id+1 cloe previous item and show new item
                                  onClick={() => {
                                    setContractItems_list((prevState) => {
                                      const newState = [...prevState];
                                      newState.splice(index + 1, 0, {
                                        ...item,
                                        // get highest id and add 1
                                        id:
                                          Math.max(
                                            ...newState.map((item) => item.id)
                                          ) + 1,
                                        NewItemLine: true,
                                      });
                                      return newState;
                                    });
                                    // close previous item
                                    setContractItems_list((prevState) => {
                                      const newState = [...prevState];
                                      newState.find(
                                        (newStateItem) =>
                                          newStateItem.id === item.id
                                      ).show_item = false;
                                      return newState;
                                    });
                                  }}
                                  className="btn btn-primary m-0 p-1 pe-2 ps-2"
                                >
                                  <i className="fa-solid fs-8 fa-copy"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                          {item?.show_item && (
                            <div className={"contract-item-section1"}>
                              <div className={"contract-item-section1-row"}>
                                <div className={""}>
                                  <Label className="form-label">Product</Label>

                                  <Select
                                    placeholder={"Choose Product"}
                                    className="mb-0 job-select2"
                                    value={item?.selectedProduct}
                                    onChange={(e) => {
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        // newState[index].selectedProduct = e;
                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).selectedProduct = e;
                                        return newState;
                                      });
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];

                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).rate = isEmpty(
                                          productList
                                            ?.find((item) => item?.Id === e.id)
                                            ?.productpricing_list?.find(
                                              (customer) =>
                                                customer.Customer_Id ===
                                                contractItemObject?.Customer_Id
                                            )
                                        )
                                          ? productList?.find(
                                              (item) => item?.Id === e.id
                                            )?.AmountLocalSubTotal
                                          : productList
                                              ?.find(
                                                (item) => item?.Id === e.id
                                              )
                                              ?.productpricing_list?.find(
                                                (customer) =>
                                                  customer.Customer_Id ===
                                                  contractItemObject?.Customer_Id
                                              )?.AmountLocalSubTotal;
                                        //Vat Rate
                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).vatRate = isEmpty(
                                          productList
                                            ?.find((item) => item?.Id === e.id)
                                            ?.productpricing_list?.find(
                                              (customer) =>
                                                customer.Customer_Id ===
                                                contractItemObject?.Customer_Id
                                            )
                                        )
                                          ? productList?.find(
                                              (ProductListitem) =>
                                                ProductListitem.Id === e.id
                                            )?.AmountVatPercentage
                                          : productList
                                              ?.find(
                                                (ProductListitem) =>
                                                  ProductListitem.Id === e.id
                                              )
                                              ?.productpricing_list?.find(
                                                (customer) =>
                                                  customer.Customer_Id ===
                                                  contractItemObject?.Customer_Id
                                              )?.AmountVatPercentage;
                                        //Product Unity Type

                                        newState[index].selectedProductUnit =
                                          productUnitTypeList?.find(
                                            (unitType) =>
                                              unitType.Id ===
                                              productList?.find(
                                                (item) => item.Id === e.id
                                              )?.UnitType_Id
                                          )?.Id
                                            ? {
                                                label:
                                                  productUnitTypeList?.find(
                                                    (unitType) =>
                                                      unitType?.Id ===
                                                      productList?.find(
                                                        (productItem) =>
                                                          productItem?.Id ===
                                                          e.id
                                                      )?.UnitType_Id
                                                  )?.Name,
                                                value:
                                                  productUnitTypeList?.find(
                                                    (unitType) =>
                                                      unitType?.Id ===
                                                      productList?.find(
                                                        (item) =>
                                                          item?.Id === e.id
                                                      )?.UnitType_Id
                                                  )?.Id,
                                                id: productUnitTypeList.find(
                                                  (unitTypeList) =>
                                                    unitTypeList?.Id ===
                                                    productList?.find(
                                                      (ProductListitem) =>
                                                        ProductListitem?.Id ===
                                                        e.id
                                                    )?.UnitType_Id
                                                )?.Id,
                                              }
                                            : [];
                                        // Change #100719 - the product's contract pricing default, when it has one
                                        const pickedProduct = productList?.find(
                                          (productItem) => productItem?.Id === e.id
                                        );
                                        const pricingRow = newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        );
                                        if (
                                          pickedProduct?.ContractPricingSource ===
                                          "CUSTOM"
                                        ) {
                                          pricingRow.PricingSource = "CUSTOM";
                                        } else if (
                                          pickedProduct?.ContractPricingSource ===
                                          "PRODUCT"
                                        ) {
                                          pricingRow.PricingSource = "PRODUCT";
                                          pricingRow.PricingDateMode =
                                            pickedProduct?.ContractPricingDateMode ||
                                            "PERIOD_START";
                                        }
                                        return newState;
                                      });
                                    }}
                                    options={
                                      !isEmpty(productList)
                                        ? productList?.filter(isProductActive).map((item) => ({
                                            label: item?.Name,
                                            value: item?.Id,
                                            id: item?.Id,
                                          }))
                                        : []
                                    }
                                    id="country-select"
                                  ></Select>
                                  {/*if job status is clear then show select button*/}
                                </div>
                              </div>
                              <div
                                className={"contract-item-section1-row pt-1"}
                              >
                                <label>Title</label>
                                <input
                                  className={"form-control bg-light border-0"}
                                  type={"text"}
                                  placeholder={"Enter Title"}
                                  value={item?.Title}
                                  onChange={(e) =>
                                    setContractItems_list((prevState) => {
                                      const newState = [...prevState];
                                      // newState[index].Title = e.target.value;
                                      newState.find(
                                        (newStateItem) =>
                                          newStateItem.id === item.id
                                      ).Title = e.target.value;
                                      return newState;
                                    })
                                  }
                                />
                              </div>
                              <div
                                className={"contract-item-section1-row pt-1"}
                              >
                                <Label>Description</Label>
                                <textarea
                                  className={"form-control bg-light border-0"}
                                  rows={1}
                                  placeholder={"Enter Description"}
                                  value={item?.Description}
                                  onChange={(e) =>
                                    setContractItems_list((prevState) => {
                                      const newState = [...prevState];

                                      newState.find(
                                        (newStateItem) =>
                                          newStateItem.id === item.id
                                      ).Description = e.target.value;
                                      return newState;
                                    })
                                  }
                                />
                              </div>
                              <div
                                className={"contract-item-section1-row pt-1"}
                              >
                                <hr />
                              </div>
                              <div
                                className={
                                  "contract-item-section1-row pt-1 d-flex"
                                }
                              >
                                <div
                                  className={
                                    "contract-quantity-module d-flex flex-column pe-2 w-100 justify-content-center"
                                  }
                                >
                                  <div className={"pb-2"}>
                                    <label>Quantity</label>
                                  </div>

                                  <div className=" quantity-contract-item-container d-flex justify-content-start">
                                    <button
                                      type="button"
                                      className="minus"
                                      onClick={() =>
                                        // (count > 0 ? count - 1 : count)
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).quantity =
                                            newState.find(
                                              (newStateItem) =>
                                                newStateItem.id === item.id
                                            ).quantity > 0
                                              ? newState.find(
                                                  (newStateItem) =>
                                                    newStateItem.id === item.id
                                                ).quantity - 1
                                              : newState.find(
                                                  (newStateItem) =>
                                                    newStateItem.id === item.id
                                                ).quantity;
                                          return newState;
                                        })
                                      }
                                    >
                                      –
                                    </button>
                                    <input
                                      type="number"
                                      className="contract-item-product-quantity"
                                      id="product-qty-1"
                                      value={item?.quantity}
                                      onChange={(e) => {
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).quantity = Number(e.target.value);
                                          return newState;
                                        });
                                      }}
                                    />
                                    <button
                                      type="button"
                                      className="plus"
                                      onClick={() =>
                                        // setCount(count + 1)
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).quantity =
                                            newState.find(
                                              (newStateItem) =>
                                                newStateItem.id === item.id
                                            ).quantity + 1;
                                          return newState;
                                        })
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                                <div
                                  className={"contract-unit-type-module w-100"}
                                >
                                  <label>Select Product Unit</label>
                                  <Select
                                    className="mb-0 job-select2 contract-item-select-product-unit"
                                    value={item.selectedProductUnit}
                                    onChange={(e) =>
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).selectedProductUnit = e;
                                        return newState;
                                      })
                                    }
                                    options={
                                      !isEmpty(productUnitTypeList)
                                        ? productUnitTypeList?.map((item) => ({
                                            label: item?.Name,
                                            value: item?.Id,
                                            id: item?.Id,
                                          }))
                                        : []
                                    }
                                    id="country-select"
                                  ></Select>
                                </div>
                              </div>
                              <div
                                className={"contract-item-section1-row pt-1"}
                              >
                                <hr />
                              </div>
                              <div
                                className={
                                  "contract-item-section1-row pt-1 d-flex"
                                }
                              >
                                <div
                                  className={
                                    "contract-item-module-column text-end pe-1"
                                  }
                                >
                                  <label>Price Each</label>
                                  <Input
                                    type="text"
                                    className="form-control product-line-price bg-light border-0 align-all-text-to-the-right"
                                    id="productRate-2"
                                    placeholder={"£" + item?.rate}
                                    value={"£" + item?.rate}
                                    onChange={(e) => {
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).rate = handleRemovePoundRate(
                                          e.target.value
                                        );

                                        return newState;
                                      });
                                    }}
                                    // once focus off then .toFixed(2) the item.rate
                                    onBlur={(e) => {
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).rate = Number(
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).rate
                                        ).toFixed(2);
                                        return newState;
                                      });
                                    }}
                                  />
                                </div>
                                <div
                                  className={
                                    "contract-item-module-column text-end pe-1"
                                  }
                                >
                                  <label>VAT Rate %</label>
                                  <Input
                                    type="text"
                                    className="form-control bg-light border-0 product-line-price align-all-text-to-the-right"
                                    id="productPrice-1"
                                    placeholder={item?.vatRate + "%"}
                                    value={item?.vatRate + "%"}
                                    onChange={(e) =>
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).vatRate = handleRemoveVatRate(
                                          e.target.value
                                        );
                                        return newState;
                                      })
                                    }
                                  />
                                </div>
                                {/* Change #100719 - price from the product, or keep this line's own price */}
                                <div
                                  className={
                                    "contract-item-module-column text-end pe-1"
                                  }
                                >
                                  <label>Price</label>
                                  <Input
                                    type="select"
                                    className="form-control bg-light border-0"
                                    value={
                                      item?.PricingSource === "PRODUCT"
                                        ? "PRODUCT:" +
                                          (item?.PricingDateMode ||
                                            "PERIOD_START")
                                        : "CUSTOM"
                                    }
                                    onChange={(e) => {
                                      const [source, mode] =
                                        e.target.value.split(":");
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        const row = newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        );
                                        row.PricingSource = source;
                                        if (mode) row.PricingDateMode = mode;
                                        return newState;
                                      });
                                    }}
                                  >
                                    <option value="CUSTOM">Custom price</option>
                                    <option value="PRODUCT:PERIOD_START">
                                      Product price, at period start
                                    </option>
                                    <option value="PRODUCT:INVOICE_DATE">
                                      Product price, on invoice date
                                    </option>
                                    <option value="PRODUCT:PRORATA">
                                      Product price, pro rata
                                    </option>
                                  </Input>
                                </div>
                                <div
                                  className={
                                    "contract-item-module-column text-end"
                                  }
                                >
                                  <label>Sub Total</label>
                                  <Input
                                    type="text"
                                    className="form-control bg-light border-0 product-line-price align-all-text-to-the-right"
                                    id="productPrice-1"
                                    placeholder="$0.00"
                                    value={
                                      "£" +
                                      (item.rate * item.quantity).toFixed(2)
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div
                                className={"contract-item-section1-row pt-1"}
                              >
                                <hr />
                              </div>
                              <div
                                className={
                                  "contract-item-section1-row pt-1 d-flex"
                                }
                              >
                                <div
                                  className={
                                    "contract-item-module-column w-100 pe-1"
                                  }
                                >
                                  {" "}
                                  <Label
                                    htmlFor="address"
                                    className="form-label"
                                  >
                                    Start Date
                                  </Label>
                                  <div className={"d-flex flex-row w-100"}>
                                    <AppDatePicker
                                      slotProps={{
                                        textField: {
                                          placeholder: "Select Start Date",
                                        },
                                      }}
                                      value={
                                        item?.StartDateTime
                                          ? moment(item?.StartDateTime)
                                          : null
                                      }
                                      onChange={(val) => {
                                        const jsDate =
                                          val && val.isValid()
                                            ? val.toDate()
                                            : null;
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).StartDateTime = jsDate
                                            ? handleValidDateTime(jsDate)
                                            : "";
                                          return newState;
                                        });
                                      }}
                                    />
                                    <span
                                      onClick={() => {
                                        // reset start date
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).StartDateTime = "";
                                          return newState;
                                        });
                                      }}
                                      className={"btn btn-danger"}
                                    >
                                      <i className="fa-solid fa-xmark"></i>
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className={
                                    "contract-item-module-column w-100 "
                                  }
                                >
                                  <Label
                                    htmlFor="address"
                                    className="form-label"
                                  >
                                    End Date
                                  </Label>
                                  <div className={"d-flex flex-row w-100"}>
                                    <AppDatePicker
                                      slotProps={{
                                        textField: {
                                          placeholder: "Select End Date",
                                        },
                                      }}
                                      value={
                                        item?.EndDateTime
                                          ? moment(item?.EndDateTime)
                                          : null
                                      }
                                      onChange={(val) => {
                                        const jsDate =
                                          val && val.isValid()
                                            ? val.toDate()
                                            : null;
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).EndDateTime = jsDate
                                            ? handleValidDateTime(jsDate)
                                            : "";
                                          return newState;
                                        });
                                      }}
                                    />
                                    <span
                                      onClick={() => {
                                        // reset end date
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).EndDateTime = "";
                                          return newState;
                                        });
                                      }}
                                      className={"btn btn-danger"}
                                    >
                                      <i className="fa-solid fa-xmark"></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div
                                className={"contract-item-section1-row pt-1"}
                              >
                                <div className={"d-flex"}>
                                  <div
                                    className={
                                      "contract-unit-type-module w-100 pe-1"
                                    }
                                  >
                                    <div>
                                      <label>Renewal Frequency</label>
                                      <Select
                                        title={"Please Select Start Date First"}
                                        className="mb-0 job-select2 contract-item-select-product-unit"
                                        value={item.RenewalFrequency_Id}
                                        onChange={(e) => {
                                          setContractItems_list((prevState) => {
                                            const newState = [...prevState];
                                            newState.find(
                                              (newStateItem) =>
                                                newStateItem.id === item.id
                                            ).RenewalFrequency_Id = e;
                                            return newState;
                                          });
                                        }}
                                        options={
                                          !isEmpty(
                                            contractItemRenewalFrequencyList
                                          )
                                            ? contractItemRenewalFrequencyList?.map(
                                                (item) => ({
                                                  label: item?.Name,
                                                  value: item?.Id,
                                                  id: item?.Id,
                                                })
                                              )
                                            : []
                                        }
                                        id="country-select"
                                      ></Select>
                                    </div>
                                  </div>

                                  <div
                                    className={
                                      "contract-unit-type-module w-100 pe-1"
                                    }
                                  >
                                    <Label
                                      htmlFor="address"
                                      className="form-label"
                                    >
                                      Service Renewal Date
                                    </Label>
                                    <div className={"d-flex flex-row w-100"}>
                                      <AppDatePicker
                                        slotProps={{
                                          textField: {
                                            placeholder:
                                              "Select Service Renewal Date",
                                          },
                                        }}
                                        value={
                                          item?.RenewalPeriodStartDateTime
                                            ? moment(
                                                item?.RenewalPeriodStartDateTime
                                              )
                                            : null
                                        }
                                        onChange={(val) => {
                                          const jsDate =
                                            val && val.isValid()
                                              ? val.toDate()
                                              : null;
                                          setContractItems_list((prevState) => {
                                            const newState = [...prevState];
                                            newState.find(
                                              (newStateItem) =>
                                                newStateItem.id === item.id
                                            ).RenewalPeriodStartDateTime = jsDate
                                              ? handleValidDateTime(jsDate)
                                              : "";
                                            return newState;
                                          });
                                        }}
                                      />
                                      <span
                                        onClick={() => {
                                          // reset start date
                                          setContractItems_list((prevState) => {
                                            const newState = [...prevState];
                                            newState.find(
                                              (newStateItem) =>
                                                newStateItem.id === item.id
                                            ).RenewalPeriodStartDateTime = "";
                                            return newState;
                                          });
                                        }}
                                        className={"btn btn-danger"}
                                      >
                                        <i className="fa-solid fa-xmark"></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={"mt-2"}>
                                <span>
                                  Schedule Next Invoice:{" "}
                                  {handleRenewalFrequencyDueDate(
                                    item?.RenewalPeriodStartDateTime,
                                    item?.RenewalFrequency_Id
                                  )}
                                </span>
                              </div>
                              <div
                                className={"contract-item-section1-row pt-1"}
                              >
                                <hr />
                              </div>{" "}
                              <div
                                className={"contract-item-section1-row pt-1"}
                              >
                                <div className="form-check mb-2">
                                  <Input
                                    checked={item?.AllowedJobAllocation === 1}
                                    onChange={() => {
                                      // if AllowedJobAllocation is 1 then set it to 2 if 2 then set it to 1
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).AllowedJobAllocation =
                                          item?.AllowedJobAllocation === 2
                                            ? 1
                                            : 2;
                                        return newState;
                                      });
                                    }}
                                    type="checkbox"
                                    className="form-check-input"
                                    id="same-address"
                                  />
                                  <Label
                                    className="form-check-label"
                                    htmlFor="same-address"
                                  >
                                    Allow Job Allocation
                                  </Label>
                                </div>
                                <div className="form-check mb-2">
                                  <Input
                                    checked={item?.TimeTracked === 1}
                                    onChange={() => {
                                      // if AllowedJobAllocation is 1 then set it to 2 if 2 then set it to 1
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        newState.find(
                                          (newStateItem) =>
                                            newStateItem.id === item.id
                                        ).TimeTracked =
                                          item?.TimeTracked === 2 ? 1 : 2;
                                        return newState;
                                      });
                                    }}
                                    type="checkbox"
                                    className="form-check-input"
                                    id="same-address"
                                  />
                                  <Label
                                    className="form-check-label"
                                    htmlFor="same-address"
                                  >
                                    Enable Time Tracked PDF
                                  </Label>
                                </div>
                                <div className="form-check mb-2">
                                  <Input
                                    checked={item?.FlagTimeActive === 1}
                                    onChange={() => {
                                      // if 1 then set to 0 if 0 then set to 1
                                      setContractItems_list((prevState) => {
                                        const newState = [...prevState];
                                        newState[index].FlagTimeActive =
                                          item?.FlagTimeActive === 0 ? 1 : 0;
                                        return newState;
                                      });
                                    }}
                                    type="checkbox"
                                    className="form-check-input"
                                    id="same-address"
                                  />
                                  <Label
                                    className="form-check-label"
                                    htmlFor="same-address"
                                  >
                                    Include Time for Renewal
                                  </Label>
                                </div>
                                <div className="form-check mb-2">
                                  <div>
                                    <Input
                                      checked={item?.whiteLabel}
                                      onChange={() => {
                                        // if 1 then set to 0 if 0 then set to 1
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).whiteLabel = !item?.whiteLabel;
                                          return newState;
                                        });
                                        if (!item.whiteLabel) {
                                          // set WhiteLabel__Customer_Id to null
                                          setContractItems_list((prevState) => {
                                            const newState = [...prevState];
                                            newState.find(
                                              (newStateItem) =>
                                                newStateItem.id === item.id
                                            ).WhiteLabel__Customer_Id = null;
                                            return newState;
                                          });
                                        }
                                      }}
                                      type="checkbox"
                                      className="form-check-input"
                                      id="same-address"
                                    />
                                    <Label
                                      className="form-check-label"
                                      htmlFor="same-address"
                                    >
                                      White Label
                                    </Label>
                                  </div>
                                </div>
                                {item?.whiteLabel && (
                                  <Col lg={12}>
                                    <Label
                                      className="form-check-label"
                                      htmlFor="same-address"
                                    >
                                      Select Customer
                                    </Label>
                                    <Select
                                      isClearable={true}
                                      className="mb-0 job-select2"
                                      placeholder={"Select Customer"}
                                      value={
                                        item?.whiteLabel
                                          ? {
                                              label: customersList?.find(
                                                (customer) =>
                                                  customer.Id ===
                                                  item.WhiteLabel__Customer_Id
                                              )?.FullName,
                                            }
                                          : []
                                      }
                                      onChange={(e) => {
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).WhiteLabel__Customer_Id = e?.value;
                                          return newState;
                                        });
                                      }}
                                      options={
                                        !isEmpty(customersList)
                                          ? customersList?.map((item) => ({
                                              label: item?.FullName,
                                              value: item?.Id,
                                              id: item?.Id,
                                            }))
                                          : []
                                      }
                                      id="country-select"
                                    ></Select>
                                  </Col>
                                )}
                                <div className="form-check mb-2 mt-2">
                                  <div>
                                    <Input
                                      checked={
                                        item?.FlagCommitmentEnabled === "1"
                                      }
                                      onChange={() => {
                                        // if 1 then set to 0 if 0 then set to 1
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).FlagCommitmentEnabled =
                                            item?.FlagCommitmentEnabled === "0"
                                              ? "1"
                                              : "0";
                                          return newState;
                                        });
                                      }}
                                      type="checkbox"
                                      className="form-check-input"
                                      id="same-address"
                                    />
                                    <Label
                                      className="form-check-label"
                                      htmlFor="same-address"
                                    >
                                      Commitment Periods?
                                    </Label>
                                  </div>
                                  {item?.FlagCommitmentEnabled === "1" && (
                                    <div>
                                      <hr />
                                      <div
                                        className={
                                          "contract-item-section1-row pt-1 d-flex"
                                        }
                                      >
                                        <div
                                          className={
                                            "contract-item-module-column w-100 pe-1"
                                          }
                                        >
                                          {" "}
                                          <Label
                                            htmlFor="address"
                                            className="form-label"
                                          >
                                            Start Date
                                          </Label>
                                          <AppDatePicker
                                            slotProps={{
                                              textField: {
                                                placeholder: "Select Start Date",
                                              },
                                            }}
                                            value={
                                              item?.CommitmentStartDateTime
                                                ? moment(
                                                    item?.CommitmentStartDateTime
                                                  )
                                                : null
                                            }
                                            onChange={(val) => {
                                              const jsDate =
                                                val && val.isValid()
                                                  ? val.toDate()
                                                  : null;
                                              setContractItems_list(
                                                (prevState) => {
                                                  const newState = [
                                                    ...prevState,
                                                  ];
                                                  newState.find(
                                                    (newStateItem) =>
                                                      newStateItem.id ===
                                                      item.id
                                                  ).CommitmentStartDateTime =
                                                    jsDate
                                                      ? handleValidDateTime(
                                                          jsDate
                                                        )
                                                      : "";
                                                  return newState;
                                                }
                                              );
                                            }}
                                          />
                                        </div>
                                        <div
                                          className={
                                            "contract-item-module-column w-100 "
                                          }
                                        >
                                          <Label
                                            htmlFor="address"
                                            className="form-label"
                                          >
                                            End Date
                                          </Label>
                                          <AppDatePicker
                                            slotProps={{
                                              textField: {
                                                placeholder: "Select End Date",
                                              },
                                            }}
                                            value={
                                              item?.CommitmentEndDateTime
                                                ? moment(
                                                    item?.CommitmentEndDateTime
                                                  )
                                                : null
                                            }
                                            onChange={(val) => {
                                              const jsDate =
                                                val && val.isValid()
                                                  ? val.toDate()
                                                  : null;
                                              setContractItems_list(
                                                (prevState) => {
                                                  const newState = [
                                                    ...prevState,
                                                  ];
                                                  newState.find(
                                                    (newStateItem) =>
                                                      newStateItem.id ===
                                                      item.id
                                                  ).CommitmentEndDateTime =
                                                    jsDate
                                                      ? handleValidDateTime(
                                                          jsDate
                                                        )
                                                      : "";
                                                  return newState;
                                                }
                                              );
                                            }}
                                          />
                                        </div>
                                        <div
                                          className={
                                            "contract-item-module-column w-100 ps-1"
                                          }
                                        >
                                          {" "}
                                          <Label
                                            htmlFor="address"
                                            className="form-label"
                                          >
                                            Renewal Date
                                          </Label>
                                          <AppDatePicker
                                            slotProps={{
                                              textField: {
                                                placeholder: "Select Start Date",
                                              },
                                            }}
                                            value={
                                              item?.CommitmentRenewalDateTime
                                                ? moment(
                                                    item?.CommitmentRenewalDateTime
                                                  )
                                                : null
                                            }
                                            onChange={(val) => {
                                              const jsDate =
                                                val && val.isValid()
                                                  ? val.toDate()
                                                  : null;
                                              setContractItems_list(
                                                (prevState) => {
                                                  const newState = [
                                                    ...prevState,
                                                  ];
                                                  newState.find(
                                                    (newStateItem) =>
                                                      newStateItem.id ===
                                                      item.id
                                                  ).CommitmentRenewalDateTime =
                                                    jsDate
                                                      ? handleValidDateTime(
                                                          jsDate
                                                        )
                                                      : "";
                                                  return newState;
                                                }
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="form-check mb-2">
                                  <div>
                                    <Input
                                      checked={item?.AutoEmailCustomer === "1"}
                                      onChange={() => {
                                        // if 1 then set to 0 if 0 then set to 1
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).AutoEmailCustomer =
                                            item?.AutoEmailCustomer === "0"
                                              ? "1"
                                              : "0";
                                          return newState;
                                        });
                                      }}
                                      type="checkbox"
                                      className="form-check-input"
                                      id="same-address"
                                    />
                                    <Label
                                      className="form-check-label"
                                      htmlFor="same-address"
                                    >
                                      Auto Email Customer
                                    </Label>
                                  </div>
                                </div>
                                <div className="form-check mb-2">
                                  <div>
                                    <Input
                                      checked={item?.CreditMinsShow}
                                      onChange={() => {
                                        // if 1 then set to 0 if 0 then set to 1
                                        setContractItems_list((prevState) => {
                                          const newState = [...prevState];
                                          newState.find(
                                            (newStateItem) =>
                                              newStateItem.id === item.id
                                          ).CreditMinsShow =
                                            !item?.CreditMinsShow;
                                          return newState;
                                        });
                                      }}
                                      type="checkbox"
                                      className="form-check-input"
                                      id="same-address"
                                    />
                                    <Label
                                      className="form-check-label"
                                      htmlFor="same-address"
                                    >
                                      Credit Mins
                                    </Label>
                                  </div>
                                  {item?.CreditMinsShow && (
                                    <div>
                                      <div
                                        className={
                                          "contract-item-section1-row pt-1 d-flex"
                                        }
                                      >
                                        <div
                                          className={
                                            "contract-item-module-column w-100 pe-1"
                                          }
                                        >
                                          <Input
                                            placeholder={"Credit Mins"}
                                            type="text"
                                            className="form-control"
                                            value={item?.CreditMins}
                                            onChange={(e) =>
                                              setContractItems_list(
                                                (prevState) => {
                                                  const newState = [
                                                    ...prevState,
                                                  ];
                                                  newState.find(
                                                    (newStateItem) =>
                                                      newStateItem.id ===
                                                      item.id
                                                  ).CreditMins = e.target.value;
                                                  return newState;
                                                }
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  );
                })}
              </div>
              <div className={"contract-item-section1-row pt-1 pb-4"}>
                <span
                  onClick={() => addItem()}
                  className="btn btn-soft-primary fw-medium"
                  id="add-new-item"
                >
                  <i className="ri-add-fill me-1 align-bottom"></i> Add Item
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
